import { Component , OnInit} from '@angular/core';
import { Router } from '@angular/router';

import { AuthfakeauthenticationService } from './core/services/authfake.service';
import { NativeBridgeService } from './core/services/native-bridge.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit  {

  constructor(
    private router: Router,
    private nativeBridge: NativeBridgeService,
    private authFackservice: AuthfakeauthenticationService,
  ) {}

  ngOnInit() {
    // document.getElementsByTagName("html")[0].setAttribute("dir", "rtl");

    this.nativeBridge.install((route: string) => this.router.navigateByUrl(route));

    this.authFackservice.startAutoRefresh();
  }
}
